import { t } from '@/shared/lib/i18n'

interface SignoffStatsProps {
  pendingSignoffsTotal: number
  departmentsWithoutChain: number
}

const SignoffStatsSummary = ({
  pendingSignoffsTotal,
  departmentsWithoutChain,
}: SignoffStatsProps) => {
  const stats = [
    {
      label: t('admin.signoffMonitoring.stats.pendingSignoffs'),
      value: pendingSignoffsTotal,
      highlight: false,
    },
    {
      label: t('admin.signoffMonitoring.stats.missingChains'),
      value: departmentsWithoutChain,
      highlight: departmentsWithoutChain > 0,
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-3">
      {stats.map((stat) => (
        <div key={stat.label} className="rounded-md border p-4 text-center">
          <p
            className={`text-3xl font-bold tabular-nums ${stat.highlight ? 'text-destructive' : 'text-foreground'}`}
          >
            {stat.value}
          </p>
          <p className="mt-1 text-xs text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  )
}

export default SignoffStatsSummary
